<template>

  <el-dialog
      title="分配"
      :visible.sync="isShowFenpei"
      width="700px"
      top="5vh"
      style="margin-top:20px;"
  >

    <el-form
        class="custom-form"
        ref="form"
        label-width="80px"
        label-position="right"
        style="padding: 0 24px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择部门">
            <el-select v-model="value1"
                       @change="choose1"
                       placeholder="请选择">
              <el-option
                  v-for="item in arr1"
                  :key="item.dgrId"
                  :label="item.departmentName"
                  :value="item.dgrId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择分部门" v-show="isShow">
            <el-select
                v-model="value2"
                @change="choose2"
                placeholder="请选择"
            >
              <el-option
                  v-for="(item2,index) in this.arr2"
                  :key="index+'arr2'"
                  :label="item2.departmentName"
                  :value="item2"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择组" v-show="isShow">
            <el-select
                v-model="value3"
                @change="choose3"
                placeholder="请选择"
            >
              <el-option
                  v-for="(item3,index) in this.arr3"
                  :key="index+'arr3'"
                  :label="item3.groupName"
                  :value="item3"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择员工">
            <el-select
                v-model="value4"
                @change="choose4"
                placeholder="请选择"
            >
              <el-option
                  v-for="(item4,index) in this.arr4"
                  :key="index+'arr4'"
                  :label="item4.roleName"
                  :value="item4.rid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-checkbox v-if="value4" style="margin-left: 48px"
                 @change="handleCheckedTreeExpand($event)" >
      展开/折叠</el-checkbox>
    <el-tree
        v-if="value4"
        :data="treeData"
        :props="treeProps"
        :default-expanded-keys="defaultExpandedKeys"
        node-key="id"
        show-checkbox
        ref="tree"
        style="margin-left: 48px"
    > <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.name }}</span>
        </span>
    </el-tree>
    <div slot="footer" class="dialog-footer">
      <el-button @click="isShowFenpei = false">取 消</el-button>
      <el-button type="primary" @click="Submit">分配</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ajaxPost, Baseurl} from "../../../api/api/api";

export default {
    data() {
      return {
        defaultExpandedKeys:[],
        isShowFenpei:false,
        isShow: true,
        company_id: "",
        treeData: [],  //处理后的数据
        treeProps: {
          children: "children",  //子节点字段名
          label: "name"
        },
        rid:'',
        arr1: [],
        arr2: [],
        arr3: [],
        arr4: [],
        value1: '',
        value2: '',
        value3: '',
        value4: '',
      }
    },
		created() {
		},
    methods:{
      //初始化数据
      initData(){
        this.defaultExpandedKeys = []

        this.rid = ''
        this.arr1 = []
        this.arr2 = []
        this.arr3 = []
        this.arr4 = []
        this.value1 = ''
        this.value2 = ''
        this.value3 = ''
        this.value4 = ''
      },
      //分配弹窗
      handleFenpei(companyId,treeData){
        this.initData()
        this.company_id = companyId
        this.treeData = JSON.parse(treeData)[0].children
        var company_id = {
          company_id: companyId,
        }
        ajaxPost(
            Baseurl + 'productTongTuoCategoryController/selectDepartmentListByCompanyId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr1 = res.data.data
            this.isShowFenpei  = true
          }
        })
      },
      handleCheckedTreeExpand(val){
        if (val){
          this.defaultExpandedKeys = this.$refs.tree.getCheckedNodes(false, false).map(
              i => i.id)
        } else {
          let treeList = this.treeData;
          for (let i = 0; i < treeList.length; i++) {
            this.$refs.tree.store.nodesMap[treeList[i].id].expanded = val;
          }
        }
      },
      choose1(val) {
        this.rid = ''
        this.arr2 = []
        this.arr3 = []
        this.arr4 = []
        this.value2 = ''
        this.value3 = ''
        this.value4 = ''
        let Obj = this.arr1.filter(item =>{
          return item.dgrId == val
        })[0]

        if (Obj.kind === 0) {
          this.isShow = true
          var company_id = {
            dgrId: this.value1,
            system: 2,
          }
          ajaxPost(
              Baseurl + 'roleController/selectNextInfoByDgrId',
              company_id
          ).then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              this.arr2 = res.data.data.next
            }
          })
        } else if (Obj.kind === 1) {
          this.isShow = false
          var company_id = {
            dgrId: this.value1,
            system: 2,
          }
          ajaxPost(
              Baseurl + 'roleController/selectNextInfoByDgrId',
              company_id
          ).then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              this.arr4 = res.data.data.next
            }
          })
        }
      },
      choose2(val) {
        this.rid = ''
        this.arr3 = []
        this.arr4 = []
        this.value3 = ''
        this.value4 = ''
        var company_id = {
          dgrId: val.dgrId,
          system: 3,
        }
        ajaxPost(
            Baseurl + 'roleController/selectNextInfoByDgrId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr3 = res.data.data.next
          }
        })
      },
      choose3(val) {
        this.rid = ''
        this.arr4 = []
        this.value4 = ''
        var company_id = {
          dgrId: val.dgrId,
          system: 4,
        }
        ajaxPost(
            Baseurl + 'roleController/selectNextInfoByDgrId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr4 = res.data.data.next
          }
        })
      },
      choose4(val) {
        this.rid = val
        let params = {
          rid:val
        }
        ajaxPost(
            Baseurl + 'baseCategoryController/selectBaseCategoryIdListByRid',
            params
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {

            data.forEach(item => {
              this.$refs.tree.setChecked(item, true, false);
            });
            this.defaultExpandedKeys = data
          }
        })
      },
      Submit(){
        let categoryIds = this.$refs.tree.getCheckedNodes(false, true).map(
            i => i.id
        )
        let params = {
          rid:this.rid,
          categoryIds:categoryIds
        }
        ajaxPost(
            Baseurl + '/baseCategoryRoleController/updateCategoryByRid',
            params
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '分配成功!',
            })
            this.isShowFenpei = false
            this.value1 = ''
            this.arr1 = ''
          }
        })
      }
    }
	}
</script>

<style lang="scss" scoped>
	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;
    margin-bottom: 32px;

		.Ministerbackground {
			background: #d7f0dbff;
		}
		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 80px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}
		}
		.information_content {
			width: calc(100% - 22px);
			overflow: hidden;
			padding: 10px 10px;
			border: 1px solid rgba(168,168,168,0.8);
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			border-top: none !important;
			margin-bottom: 15px;

			.information_Mandarin {
				overflow: hidden;
				// margin-left: 4%;
				display: flex;
				justify-content: space-between;

				ul {
					max-width: 1450px;
					flex: 1;
					display: flex;

					li {
						width: 90px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						// float: left;
						cursor: pointer;
					}
					.liactive {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.information_tips {
				line-height: 50px;
				margin-left: 10%;
				color: #f89a9a;
				font-size: 16px;
			}
			.information_input {
				overflow: hidden;
				position: relative;
				.region {
					width: 80px;
					height: 80px;
					background: rgba(0, 0, 0, 0);
					// background: red;
					position: absolute;
					left: 0px;
					top: 50px;
				}
				.information_Title {
					width: 8%;
					overflow: hidden;
					color: #7d7171;
					text-align: right;
					float: left;
					line-height: 33px;
					margin-right: 1%;
					font-weight: bold;
					user-select: none;
					.tips {
						color: red;
					}
				}
				.input_el {
					width: 88%;
					float: left;

					.Preservation {
						float: right;
						padding: 10px 10px;
						background: #73ade9;
						color: #fff;
						margin-top: 5px;
						border-radius: 5px;
					}
				}
			}
		}
	}
	.uploadPictures {
		/deep/ .el-upload-list__item {
			width: 178px;
			height: 178px;
		}
		/deep/ .el-upload--picture-card {
			width: 178px;
			height: 178px;
			line-height: 178px;
			padding: 0 20px;
		}
		/deep/ .selectUpload {
			// .el-upload.el-upload--picture-card,
			.el-upload-list__item-status-label {
				display: none;
			}
		}
		/deep/ .el-dialog__body {
			word-break: break-word;
		}
		.flip-list-move {
			transition: transform 0.5s;
		}
		.no-move {
			transition: transform 0s;
		}
		.ghost {
			opacity: 0.5;
			background: #c8ebfb;
		}
		.showImg {
			width: 148px;
			float: left;
			margin-right: 15px;
		}
	}
  .bianti {
    margin-left: 20px;
    font-size: 16px;
    margin-top: 12px;
    align-items: center;
    .shuxing_box{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .shuxing_box_item{
        margin-left: 20px;
        padding: 6px;
        display: flex;
        align-items: center;
      }
    }

  }

  .bianti_box{
    width: calc(100% - 22px);
    min-height: 120px;
    padding: 10px 10px;
    border: 1px solid rgba(168,168,168,0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
    padding-bottom: 20px;
  }
  .scope_img_img{
    height: 80px;
    width: 80px;
    margin-left: 12px;
    border: 1px dashed darkgrey;
    border-radius: 8px;
    cursor: pointer;
  }
  .prduct_img{
    height: 550px;
    width: 550px;
  }
</style>
